var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-97bab6dd-7247-49b6-94dd-33d3472a4666",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 1606.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-4f6af092-7960-493f-89fb-009739513eeb {\n        fill: #004a5d;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-1d4e2bf8-5925-4918-8d01-b8f36fa1fd4b",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-4f6af092-7960-493f-89fb-009739513eeb",
    d: "M0,1583.51l88.48,23.43s1082.14-329.81,1411.52-352.29c329.38,22.49,1411.55,352.29,1411.55,352.29l88.45-23.43s-941.12-646.71-1500-659.28C941.13,936.8,0,1583.51,0,1583.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4f6af092-7960-493f-89fb-009739513eeb",
    d: "M2999.99,23.43l-88.45-23.43s-1082.17,329.81-1411.52,352.29C1170.62,329.81,88.45,0,88.45,0L0,23.43s941.12,646.71,1500.03,659.28c558.84-12.57,1499.97-659.28,1499.97-659.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndra);
export default __webpack_public_path__ + "static/media/indra.948f27cb35881329a17a397f4f7e4d5a.svg";
export { ForwardRef as ReactComponent };